import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { EditTaskForm } from '@/components/tasks/EditTaskForm';

export default function EditTaskPage() {
  return (
    <ProtectedRoute>
      <EditTaskForm />
    </ProtectedRoute>
  );
}
